var exports = {
  "k": "x234b8571--4e82bb--container",
};

module.exports = exports;
